import { api } from 'API'

export async function uploadFile(
  organizationId: number,
  type: 'image' | 'video' | 'other',
  file: File,
  onUploadProgress?: (progressEvt: any) => void
): Promise<string> {
  const body = new FormData()
  body.append('file', file, file.name)
  const response = await api.post(`/cms/${type}`, body, {
    params: { organizationId },
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: onUploadProgress ?? (() => {})
  })

  // full download url
  return response.data
}

export async function uploadMultipleFiles(
  organizationId: number,
  type: 'image' | 'video' | 'other',
  files: File[],
  onUploadProgress?: (progressEvt: any) => void
): Promise<string[]> {
  const body = new FormData()
  files.forEach(file => body.append('files', file, file.name))
  const response = await api.post(`/cms/${type}/multiple`, body, {
    params: { organizationId },
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: onUploadProgress ?? (() => {})
  })

  // full download url
  return response.data
}
